import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=307b0932&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"
import style0 from "./TabsComponent.vue?vue&type=style&index=0&id=307b0932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b0932",
  null
  
)

export default component.exports